<atlas-top-bar
  [hideCenters]="hideCenters()"
  [hideLanguageSelector]="hideLanguageSelector()"
  [hideNotifications]="hideNotifications()"
  [hideUserDropdown]="disableUserDropdown()"
  [dropdownItems]="dropdownItems()"
  [hideBottomBorder]="hideBottomBorder()"
  [showDarkModeToggle]="enableDarkModeToggle()"
  [darkModeToggleContext]="darkModeToggleContext()"
>
  <ng-content></ng-content>
</atlas-top-bar>
